import { combineReducers } from "redux";
import downloadPdfReducer from "./residentialProfile";
import documentReducer from "./documentReducer";

const docReducer = combineReducers({
    document: documentReducer,
    downloadPdf: downloadPdfReducer
});

export default docReducer;
